<template>
  <main class="c-home main-contain">
    <section id="home-banner" class="parallax-background" data-paroller-factor="-0.09" data-paroller-factor-sm="-0.09" data-paroller-factor-xs="-0.09" :style="{ background: 'url('+ banner +') no-repeat center top'}">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="banner_description">
              <h1 class="blue-c-1">Need Working <br>Capital?</h1>
              <p class="blue-c-1 font-regular">Our experts specialize in helping small business owners and entrepreneurs obtain the capital they need to succeed. By having the right business financing in place, cash flow challenges can be avoided. We provide diagnostic tools that allow a business to make smart decisions and keep you focused on your business.</p>
              <a href="#quick-form" class="banner_link">Get Started </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="quick-form" class="blue-b">
      <div class="container">
        <div class="row">
          <div id="blueFormSide" class="col-md-5 inline-block verticle-middle">
            <router-link to="/" ><img src="./../../static/images/icons/border-right.png" class="br_" /></router-link>
            <h3 class="mar-no font-light white-c">About</h3>
            <h2 class="font-bold  mar-no white-c font-bold">3 Easy Steps</h2>
            <p class="mar-no font-regular white-c padd-t5">In just hours, get the cash you need.</p>
            <ul class="apply-steps">
              <li>
                <span>
                  <router-link to="/" ><img src="./../../static/images/icons/apply.png"  /></router-link>
                </span><div class="step_form_step">
                  <h6 class="white-c font-medium text-uppercase mar-no">Apply Now</h6>
                  <p class="white-c font-light">Apply online with our easy <br>two-step application</p>
                </div>
              </li>
              <li>
                <span>
                  <router-link to="/" ><img src="./../../static/images/icons/approved.png"  /></router-link>
                </span><div class="step_form_step">
                  <h6 class="white-c font-medium text-uppercase mar-no">Get Approved</h6>
                  <p class="white-c font-light">Simple approval; 4 out of 5<br>applicants get approved</p>
                </div>
              </li>
              <li>
                <span>
                  <router-link to="/" ><img src="./../../static/images/icons/fund.png"  /></router-link>
                </span><div class="step_form_step">
                  <h6 class="white-c font-medium text-uppercase mar-no">Get fUNDS</h6>
                  <p class="white-c font-light">Receive funds in your bank <br>account in as fast as 1 hour!</p>
                </div>
              </li>
            </ul>
          </div><div class="col-md-7 inline-block verticle-middle qk_frm">
            <div class="quick-form-">
              <form name="contactForm" id="contactForm"  @submit.prevent="processForm">
                <h1 class="yellow-c mar-no">Dan Advance <br>Quick Apply Form</h1>
                <h6 class="mar-no font-light white-c padd-t10 padd-b20">Apply now in seconds.</h6>
                <div id="form-result"></div>
                <div class="qform w1">
                  <input type="text" class="qform-input" name="money_need" placeholder="How much money do you need?" v-validate="'required|numeric'"  />
                  <span v-show="errors.has('money_need')" class="help is-danger">{{ errors.first('money_need') }}</span>
                </div>
                <div class="qform w1">
                    <input type="text" class="qform-input" name="annual_revenue" placeholder="Annual revenue" v-validate="'required|numeric'"  />
                    <span v-show="errors.has('annual_revenue')" class="help is-danger">{{ errors.first('annual_revenue') }}</span>
                </div>
                <div class="qform w1">
                    <input type="text" class="qform-input" name="reason_for_money" placeholder="Reason for money required" v-validate="'required'"  />
                    <span v-show="errors.has('reason_for_money')" class="help is-danger">{{ errors.first('reason_for_money') }}</span>
                </div>
                <h6 class="mar-no font-light white-c padd-t30 padd-b10">Contact Information</h6>
                <div class="qform w2">
                    <input type="text" class="qform-input" name="first_name" placeholder="First name *" v-validate="'required'"  />
                    <span v-show="errors.has('first_name')" class="help is-danger">{{ errors.first('first_name') }}</span>
                </div><div class="qform w2">
                    <input type="text" class="qform-input" name="last_name" placeholder="Last name *" v-validate="'required'"   />
                    <span v-show="errors.has('last_name')" class="help is-danger">{{ errors.first('last_name') }}</span>
                </div>
                <div class="qform w2">
                    <input type="text" class="qform-input" name="email" placeholder="Email *" v-validate="'required|email'"  />
                    <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
                </div><div class="qform w2">
                    <input type="text" class="qform-input" name="phone" placeholder="Phone no *" v-validate="'required|numeric'"  />
                    <span v-show="errors.has('phone')" class="help is-danger">{{ errors.first('phone') }}</span>
                </div>
                <div class="qform w1">
                  <vue-recaptcha sitekey="6LcVxrEUAAAAADs2q17NSpuTo9YEMI361EVDCW3J"  :loadRecaptchaScript="true"></vue-recaptcha>
                </div>
                <div class="qform w1">
                  <button class="btn btn_qform" id="SubmitContact">Submit</button>
                </div>
                <p class="small-text mar-no">By submitting your application, you agree to receive emails, notifications and news from Dan Advance. You can unsubscribe anytime.</p>
              </form>
            </div>
          </div>
        </div>  
      </div>
    </section>
    <section id="about" class="padd-tb85 parallax-background" data-paroller-factor="0.2" data-paroller-factor-sm="0.2" data-paroller-factor-xs="0.1" :style="{ background: 'url('+ about_bg +') no-repeat center top'}">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
          </div><div class="col-md-6">
            <div class="about_">
              <h3 class="mar-no">About</h3>
              <h1 class="font-bold  mar-no blue-c-1">Dan Advance</h1>
              <p class="padd-t30 font-regular">Dan Advance is the answer to small business financing. Located in the heart of the financial district in New York City, Dan Advance has a dedicated team that helps fund thousands of merchants in practically every industry. If you are a restaurant owner, a veterinarian, a salon owner, or own an auto repair business, we are here to help you.</p>
               <router-link to="/about-us" class="font-regular about-link" >Find out more</router-link>
            </div>  
          </div>
        </div>
      </div>
    </section>
    <section id="testimonials" class="text-center blue-b padd-tb85">
      <div class="container main-container">
        <div class="row">
          <div class="col-md-12">
              <h1 class="font-bold  mar-no white-c">What Our Customers Say</h1>
              <h5 class="mar-no soft-gray font-regular padd-t10">We really appreciate all of your reviews, thank you so much!</h5>
              <h6 class="white-c font-light padd-t40">"Thank you Dan Advance. It was a great experience to work with you. Your team is incredible. Despite of my personal credit you agreed to help my business with a $244,000 fund which it desperately needed. You will be getting more businesses from my friends. Thank you for treating me in a kind way and listening to my story."</h6>
              <h6 class="white-c font-regular padd-t20">BC, LNT Inc.</h6>
          </div>
        </div>
      </div>
    </section>

   <section id="MCAvis" class="padd-tb85 parallax-background" data-paroller-factor="0.2" data-paroller-factor-sm="0.2" data-paroller-factor-xs="0.1" :style="{ background: 'url('+ mca +') no-repeat center top'}">
      <div class="container main-container">
        <div class="row">
          <div class="col-md-6">
            <h1>MCA vis-a-vis<br/> Traditional Bank Loan</h1>
            <p>Approved and granted much faster than a traditional bank loan </p>
            <hr>
            <p>The rates are much higher than the banks</p>
            <hr>
            <p>The payback is linked to a percentage of future cash flows</p>
            <hr>
            <p>Collections are done on daily or weekly basis than the traditional collections from banks.</p>
          </div>
        </div>
      </div>
  </section>

    <rwv-subscribe></rwv-subscribe>
  </main>
</template>

<script>

import RwvSubscribe from '@/components/Subscribe'
import * as $ from 'jquery'

import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueRecaptcha from 'vue-recaptcha';

Vue.use(VeeValidate);

export default{
  name: 'Home',
  components: {
    RwvSubscribe, VueRecaptcha
  },
  data: function() {
    return {
      banner:require('./../../static/images/home.jpg'),
      about_bg:require('./../../static/images/about.jpg'),
      mca: require('./../../static/images/the-mca-vis-bg.jpg'),
    }
  },
  mounted() {

  },
  methods: {
    processForm: function() {
      //console.log({ name: this.name, email: this.email });
      //alert('Processing!');

        this.$validator.validateAll().then((result) => {
        if (result) {
            //alert("success");
      
              //replace submit button with loader
              $( "#SubmitContact" ).fadeOut('fast', function(){
                  $( '<img src="'+ require('./../../static/images/loader.gif') +'" id="loader_gif" />' ).insertAfter(this);
              });

              // Send the data using post
              var form = $( "#contactForm" );  
              var posting = $.post('https://danadvance.com/cash/ajax/apply-now-quick.php', form.serialize() );

              // Put the results in a div
              posting.done(function( data ) {
                var obj = $.parseJSON(data);
                $( "#form-result" ).empty().append( obj.msg );
                if(obj.success == 'true')
                {
                  //success
                  form.find("input[type=text], input[type=email], input[type=tel], input[type=number], textarea").val("");//reset
                }
                $( "#SubmitContact" ).fadeIn('fast', function(){
                  $( '#loader_gif' ).remove();
                  grecaptcha.reset();
                });
              });

        }
        });      
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/views/Home.vue